import React from "react";

import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import { Card, CardBody, CardHeader } from "reactstrap";



import { AntragstellerFirmaOPSConsts, MediumOPSConsts } from "../TempConstantsCommon";

// import logo from "./assets/RohrgefuehrteMedienLogo.png";
import logo from "./assets/RohrgefuehrteMedienLogo.svg";
import AntragHeader from "../../common/components/request/AntragHeader";
import RohrgefuehrteMedienRequest from "./components/request/RohrgefuehrteMedienRequest";
import { FormFieldsCommon } from "../../common/CommonConstants";
import { FormFieldsRM } from "./components/request/RohrgefuehrteMedienRequestConstants";


const paramNameAutoComplete = "autoC";
const paramNameNoSubmit = "noS";
const paramNameNoFormDisable = "noFD";

class RohrgefuehrteMedien extends React.Component {

  private _autoCompleteMode: string;
  private _noSubmit: boolean;
  private _noFormDisable: boolean;

  constructor(props: any) {
    super(props);

    initializeIcons();

    const params = new URLSearchParams(window.location.search);

    this._autoCompleteMode = params.has(paramNameAutoComplete) ? "on" : "new-password";
    this._noSubmit = params.has(paramNameNoSubmit);
    this._noFormDisable = params.has(paramNameNoFormDisable);
  }

  render() {

    return (
      <React.Fragment>
                <Card
          style={{ maxWidth: "1440px", margin: "20px auto" }}
        >
          <CardHeader>
            <AntragHeader 
              caption="Antrag/Änderung Anschluss rohrgeführter Medien" 
              // logo={null}
              logo={logo}
              logoStyle={{width: '222px', margin: '23px 24px 24px 0'}}
            />
          </CardHeader>
          <CardBody
            style={{ padding: 22 }} 
          >
            <RohrgefuehrteMedienRequest
              formFields={FormFieldsCommon.concat(FormFieldsRM)}
              companies={AntragstellerFirmaOPSConsts}
              medien={MediumOPSConsts}
              autoCompleteMode={this._autoCompleteMode}
              noSubmit={this._noSubmit} 
              noFormDisable={this._noFormDisable}
            />              
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default RohrgefuehrteMedien;
